import { useEffect, useState } from "react";
import { Accordion, Button, Container} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaCalendarAlt, FaTruck} from "react-icons/fa";
import { useSelector } from "react-redux";
import BarraMenuHz from "../../../components/BarraMenoHz";
import LocalMsgModalSpinner from "../../../components/LocalMsgModalSpinner";
import MsgModalDialogEspecial from "../../../components/MsgModalDialogEspecial";
import * as env from '../../../env';
import { httpApiGetText} from "../../../lib";
import { exportToExcel } from "../../../util";
import Multiselect from "multiselect-react-dropdown";

const RespaldoPage = () =>{

    let emp: any = useSelector((state: any) => state.emp);
    const [records, setRecords] = useState([]);
    const [cpRecords, setCpRecords] = useState([]);    
    const [centros, setCentros] = useState([]);    
    const [almacenesFiltrados, setAlmacenesFiltrados] = useState([]);
    const [almacenesSelected, setAlmacenesSelected] = useState([]);    
    const [btnToExcel, setBtnToExcel] = useState(true);
    const [sHCarga, setSHCarga] = useState(false);
    const [hbltBtnAbrir, setHbltBtnAbrir] = useState(true);    
    const [fechaInicial, setFechaInicial] = useState("dd/MM/yyyy");
    const [fechaFinal, setFechaFinal] = useState("dd/MM/yyyy");
    const [fechaMin, setFechaMin] = useState("dd/MM/yyyy");      
    const [codigoSku, setCodigoSku] = useState("");       
    const [habilitaFechas, setHabilitaFechas] = useState(true); 
    const [habilitaCodigoSku, setHabilitaCodigoSku] = useState(true);           
    let [formData, setFormData] = useState({ Pais: "CL", Anno: "", Mes: "",  Centro: "", Almacen: ""}); 
    const [msgDlgShowApiResponse, setMsgDlgShowApiResponse] = useState(false);
    const [msgRespuestInv, setMsgRespuestInv] = useState(""); 

    //*********Configuración de la Grilla */
    let columns = [
        { name: "Centro", selector: (row:any) => row.CENTRO, sortable: true, width:"90px"},
        { name: "Almacén", selector: (row:any) => row.ALMACEN, sortable: true, width:"100px"},
        { name: "Especial", selector: (row:any) => row.ESPECIAL, width:"90px", sortable: true},        
        { name: "Fecha Contabilización", selector: (row:any) => row.FECHA_CONTAB, width:"170px", sortable: true},
        { name: "Fecha Registro", selector: (row:any) => row.FECHA_REGISTRO, width:"160px", sortable: true, wrap:true},
        { name: "Hora entrada", selector: (row:any) => row.HORA_ENTRADA, width:"120px", sortable: true, wrap:true},     
        { name: "Usuario", selector: (row:any) => row.USUARIO, width:"130px", sortable: true, wrap:true},
        { name: "C.I. Move", selector: (row:any) => row.MOV, width:"100px", sortable: true, wrap:true, right: true},             
        { name: "Doc. Material", selector: (row:any) => row.DOC_MATERIAL, sortable: true, width:"130px"},    
        { name: "Material", selector: (row:any) => row.INV_ITEM_ID, sortable: true, width:"160px"},                 
        { name: "Descripción", selector: (row:any) => row.DESCRIPCION, sortable: true, width:"280px", wrap: true},   
        { name: "Ctd. UME", selector: (row:any) => row.CTD_UME, format: (row:any) => row.CTD_UME.toLocaleString(), right:true, sortable: true, width:"120px"},                
        { name: "UME", selector: (row:any) => row.UME, sortable: true, width:"90px"}, 
        { name: "Texto Cab. Doc", selector: (row:any) => row.TEXTO_CAB_DOCUMENTO, sortable: true, width:"160px"},       
    ]

    const pagOptions = {
        rowsPerPageText: "Filas por páginas",
        rangeSeparatorText: "de",
        selectAllRowsItem: true,
        selectAllRowsItemText: "Todos"
    };  

    const changeTextFiltro = (evnt: any) => {
        if (evnt.target.value.trim() === ""){
            setRecords(cpRecords);  
        }else{
            let reg = cpRecords.filter((dato: any)=> {
                return (dato.CENTRO && dato.CENTRO.includes(evnt.target.value.toUpperCase()))
                    || (dato.ALMACEN && dato.ALMACEN.includes(evnt.target.value.toUpperCase())) 
                    || (dato.ESPECIAL && dato.ESPECIAL.includes(evnt.target.value.toUpperCase()))
                    || (dato.INV_ITEM_ID && dato.INV_ITEM_ID.includes(evnt.target.value.toUpperCase()))  
                    || (dato.DESCRIPCION && dato.DESCRIPCION.includes(evnt.target.value.toUpperCase())) 
                    || (dato.FECHA_CONTAB && dato.FECHA_CONTAB.includes(evnt.target.value.toUpperCase()))                     
                    || (dato.FECHA_REGISTRO && dato.FECHA_REGISTRO.includes(evnt.target.value.toUpperCase())) 
                    || (dato.HORA_ENTRADA && dato.HORA_ENTRADA.includes(evnt.target.value.toUpperCase())) 
                    || (dato.USUARIO && dato.USUARIO.includes(evnt.target.value.toUpperCase()))  
                    || (dato.MOV && dato.MOV.includes(evnt.target.value.toUpperCase())) 
                    || (dato.DOC_MATERIAL && dato.DOC_MATERIAL.includes(evnt.target.value.toUpperCase()))        
                    || (dato.CTD_UME && dato.CTD_UME.includes(evnt.target.value.toUpperCase()))                      
                    || (dato.UME && dato.UME.includes(evnt.target.value.toUpperCase()))  
                    || (dato.TEXTO_CAB_DOCUMENTO && dato.TEXTO_CAB_DOCUMENTO.includes(evnt.target.value.toUpperCase()));                     
            }); 
            setRecords(reg); 
        }
    }  
    //**********fin configuración de grillas************ */

    const hndlrBtnBuscar = async () =>{

        setRecords([]);

        const fechIni = fechaInicial.substring(8, 10) + "/" + fechaInicial.substring(5, 7) + "/" + fechaInicial.substring(0, 4) ;           

        const fechFin = fechaFinal.substring(8, 10) + "/" + fechaFinal.substring(5, 7) + "/" +  fechaFinal.substring(0, 4) ;         
     
        let dts: string = "";
        almacenesSelected.map((dato: any)=>{
            dts = `${dato.cat};${dato.key.split(' - ')[0].trim()}-${dts}`;
        });
      
        dts = dts.substring(0, dts.length - 1);
        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/Kardex?Pais=CL&CentroAlmacen=${dts}&fechaIni=${fechIni}&fechaFin=${fechFin}&Codigo=${codigoSku}`;     
        const response = await httpApiGetText(recurso,{
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        setSHCarga(false);
        const arrDta = await JSON.parse(response.message);   
        const auxDta:any = [];
        if (response.code >= 400){
            setMsgRespuestInv(arrDta.Message);
            setMsgDlgShowApiResponse(true);
            setRecords(auxDta);              
        }
        else{
            if (arrDta.length > 0){  
                arrDta.map((valor: any, index: number)=>{
                    const newObj = {
                        PAIS:valor.PAIS,                        
                        CENTRO:valor.CENTRO,
                        ALMACEN:valor.ALMACEN,
                        ESPECIAL:valor.ESPECIAL,
                        FECHA_CONTAB:valor.FECHA_CONTAB,
                        FECHA_REGISTRO:valor.FECHA_REGISTRO,
                        HORA_ENTRADA:valor.HORA_ENTRADA,
                        USUARIO:valor.USUARIO,
                        MOV:valor.MOV,                        
                        DOC_MATERIAL:valor.DOC_MATERIAL,                              
                        INV_ITEM_ID:valor.INV_ITEM_ID,                                
                        DESCRIPCION:valor.DESCRIPCION,
                        CTD_UME:valor.CTD_UME,
                        UME:valor.UME,   
                        TEXTO_CAB_DOCUMENTO:valor.TEXTO_CAB_DOCUMENTO
                    }
                    auxDta.push(newObj);
                }); 
                //********Pasa el objeto a arreglo para recorrido en table
                setRecords(auxDta); 
                setCpRecords(auxDta);
                setBtnToExcel(false);
            }else{
                setBtnToExcel(true);
            }       
        }
        setFechaMin(`${formData.Anno}-${formData.Mes}-01`);        
    }

    const MsgDlghandlerResponseApi = () =>{
        setMsgDlgShowApiResponse(false);
    }  

    const exportAExcell = (name: string, data: any) =>{

        exportToExcel(name, data)
    }

    const habilitaBuscar = (lng: number) => {
        
        setHbltBtnAbrir(!lng);

    }

    const onSelectedOptionCenter = (e: any) =>{
         
        if (e.length > 0){
            const almacenes: any = [];
            e.map((dato: any)=>{
                const alma = emp.almacenes.filter( (alm: string)=> alm.includes(dato.cat) );
                //organiza la estructura de almacens así: {cat: id, key: label} paramostrar en el multiselect
                alma.map((dt: string) => {
                    const cnt = dato.cat;
                    const almcn = `${dt.split(' - ')[1]} - ${dt.split(' - ')[2]}`; 
                    almacenes.push({cat : cnt, key : almcn});
                });
            });

            setAlmacenesFiltrados(almacenes);    
        }else{
            setAlmacenesFiltrados([]);            
        }

    }

    const onRemoveOptionCenter = (e: any, centRmv: any) =>{
        
        const almcremv = almacenesSelected.filter((dato: any) => dato.cat !== centRmv.cat);
        setAlmacenesSelected(almcremv);
        if (almcremv.length < 1){
            setAlmacenesFiltrados([]);
        }

        if (e.length > 0){
            const almacenes: any = [];
            e.map((dato: any)=>{
                const alma = emp.almacenes.filter( (alm: string)=> alm.includes(dato.cat) );
                //organiza la estructura de almacens así: {cat: id, key: label} paramostrar en el multiselect
                alma.map((dt: string) => {
                    const cnt = dato.cat;
                    const almcn = `${dt.split(' - ')[1]} - ${dt.split(' - ')[2]}`; 
                    almacenes.push({cat : cnt, key : almcn});
                });
            });

            setAlmacenesFiltrados(almacenes);    
        }else{
            setAlmacenesFiltrados([]);            
        }

        habilitaBuscar(almcremv.length);
    }
    
    const onSelectedOptionAlmacen = (e: any) =>{

        setAlmacenesSelected(e);
        habilitaBuscar(e.length);

    }

    const onRemoveOptionAlmacen = (e: any) =>{
        
        habilitaBuscar(e.length);
    }

    const handlerFechaI = (e: any) =>{
        
        setFechaInicial(e.target.value);
        setFechaFinal(e.target.value); 
        setHabilitaFechas(false);
        setHabilitaCodigoSku(false);

    }

    const handlerFechaF = (e: any) =>{
        
        setFechaFinal(e.target.value);  
        setHabilitaCodigoSku(false);
    }    

    //Metodo que valida si es un valor númerico válido
    const InputValid = (e: any) =>{
        if (!e.target.validity.valid) {
            e.target.value = e.target.value.replace(/[^0-9]+/g, '');  // Remueve caracteres no numéricos
        }
    }

    // Método que elimina caracteres no acptados
    const ChangeInputInvalid = (e: any) =>{
        // Elimina caracteres no numéricos
        const inputValue = e.target.value;
        return (inputValue.replace(/[^0-9]/g, '')); // Elimina caracteres no numéricos
    }    
    
    useEffect(()=>{

        const preFiltros = () =>{
            if ((emp.periodoDefault !== "")){
                formData = { ...formData, Anno: emp.periodoDefault.split("-")[0],  Mes: emp.periodoDefault.split("-")[1]};
                setFormData(formData);     
                setHabilitaFechas(false);                                    
            }  
            if ((emp.centroDefault !== "")){
                formData = { ...formData, Centro: emp.centroDefault.split("-")[0].trim()};
                setFormData(formData);                                        
            }    
            if ((emp.almacenDefault !== "")){
                formData = { ...formData, Almacen: emp.almacenDefault.split("-")[0].trim()};
                setFormData(formData);                                        
            } 
        }

        preFiltros();  

        const centros: any = [];
        emp.centros.map((dt: string) => {
            const cnt = dt.split(' - ')[0];
            const nmCnt = `${cnt} - ${dt.split(' - ')[1]}`; 
            centros.push({cat : cnt, key : nmCnt});
        });   
        setCentros(centros);
    }, []);   

    return(
        <Container fluid>
            <BarraMenuHz/>  
            <div >
                <div className="text-primary ms-3 mt-3">
                        Home / Auditoria / Detalle ajustes
                </div>
                <div className="h4 mt-4 mb-4 ms-3">DETALLE AJUSTES</div>
            </div> 
            <Container fluid>
                <Accordion  className="mb-4" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header><div className=" h5 text-dark">PARÁMETROS</div></Accordion.Header>
                        <Accordion.Body>
                            <label className="h6 mb-3">Recuerda completar todos los campos con *</label> 
                            <div className="align-middle">
                                <FaCalendarAlt className="h5" /> 
                                <label className="ms-2 h4 ">Período</label>
                            </div>
                            <hr className="t-0 m-0 mb-3" />
                            <div className="row">
                                <div  className="d-flex flex-column  col-lg-4 ">
                                    <label className="m-2 ">Fecha ajuste desde</label>
                                    <input type="date" id="fechaInicial" size={8}  className="ms-2 mb-1 "
                                        onChange={handlerFechaI}
                                        value={fechaInicial} 
                                        min={fechaMin}
                                    />                                    
                                </div> 
                                <div  className="d-flex flex-column  col-lg-4 ">
                                    <label className="m-2 ">Fecha ajuste hasta</label>
                                    <input type="date" id="fechaFinal" size={8}  className="ms-2 mb-1"
                                        onChange={handlerFechaF}
                                        value={fechaFinal} 
                                        min={fechaInicial}
                                        disabled={habilitaFechas}
                                    />                                    
                                </div>  
                                <div  className="d-flex flex-column  col-lg-4 ">
                                    <label className="m-2 ">Código SKU</label>
                                    <input type="number" id="codigoSku" size={8}  className="ms-2 mb-1"
                                        pattern="\d*"
                                        onInput={(e: any) => InputValid(e)}
                                        onChange={(e: any) => setCodigoSku(ChangeInputInvalid(e))}  
                                        value={codigoSku} 
                                        min={0}
                                        disabled={habilitaCodigoSku}
                                        placeholder="Deje vacia esta casilla para traer todos los código SKU"
                                    />                                   
                                </div>                                   
                            </div>                                                   
                            <hr className="t-0 m-0 mt-3" />                            
                            <div className="align-middle mt-4">
                                <FaTruck className="h5" /> 
                                <label className="ms-2 h4 ">Centro y Almacen</label>
                            </div>
                            <hr className="t-0 m-0 mb-3" /> 

                            <div className="row d-flex flex-row mb-3">
                                <Container fluid className="mb-3 col-md-12 col-lg-6" >
                                    <label className="form-label">Seleccionar Centro de distribución</label>    
                                    <div>
                                        <Multiselect className="" aria-label="Default select example" 
                                            onSelect={(e: any)=>onSelectedOptionCenter(e)}
                                            onRemove={(e: any, remcnt: any)=>onRemoveOptionCenter(e, remcnt)}
                                            options={centros}
                                            displayValue="key"
                                            placeholder="Centros de distribución"
                                        />
                                    </div>
                                </Container>
                                <Container fluid className="mb-3  col-md-12 col-lg-6" >
                                    <label className="form-label">Seleccionar Almacen </label>    
                                    <div>
                                        <Multiselect className="" aria-label="Default select example" 
                                            onSelect={(e: any)=>onSelectedOptionAlmacen(e)}  
                                            onRemove={onRemoveOptionAlmacen}                                         
                                            options={almacenesFiltrados}
                                            displayValue="key"
                                            placeholder="Almacen(es)"
                                            selectedValues={almacenesSelected}
                                        />
                                    </div>
                                </Container>
                            </div>

                            <div className="text-end">
                                <Button type="button" className=" btn border border-0" 
                                    disabled={hbltBtnAbrir}  onClick={hndlrBtnBuscar} style={{backgroundColor: "#00B5B8"}}
                                >
                                    Buscar
                                </Button>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>         

                <Accordion className="mt-1" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header><div className=" h5 text-dark">DETALLE</div></Accordion.Header>
                        <Accordion.Body>
                            <div className="text-start mb-4">
                                    <div className="d-flex flex-column col col-lg-6 mb-3 ">
                                        <label className="m-1">Filtro</label>
                                        <input type="text" id="txtBuscar" className="form-control m-1" onChange={changeTextFiltro}/>
                                    </div>  
                                    <div className="m-1 col-md-12 col-lg-8 " > 
                                        <Button type="button" className="border-0" style={{backgroundColor:"#16D39A"}}
                                            disabled={btnToExcel}
                                            onClick={async ()=> exportAExcell("DetalleAjuste", records)}>
                                            Exportar
                                        </Button>
                                    </div>                                     
                            </div>
                            <DataTable
                                columns={columns}
                                data={records}
                                fixedHeader
                                pagination
                                highlightOnHover
                                fixedHeaderScrollHeight="600px"
                                paginationComponentOptions={pagOptions}                             
                            />    
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>  
            </Container>
            {/*********** cuadro de dialogo para msj de api **********/}
            <MsgModalDialogEspecial
                Show={msgDlgShowApiResponse}
                Title={`Respaldo documentario`}
                Icon="x"
                Message={msgRespuestInv}
                BtnOkName="Aceptar"
                BtnNokName=""
                HandlerClickOk={MsgDlghandlerResponseApi}
                HanlerdClickNok={null}
            /> 

            <LocalMsgModalSpinner 
                Show={sHCarga}
                text="Un momento por favor, procesando..."
                color="#FF7588"
            />              
        </Container>
    );
}

export default RespaldoPage;
